import React, { useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import PrintSettingsFields from '~/pages/LeLens/print/PrintSettingsFields';
import { DEFAULT_PRINT_SETTINGS, type PrintSettings } from '~/pages/LeLens/print/printSettings';

/** The native report "Download PDF" settings, shared by the ⋮ menu and reports with their own PDF export. */
export default function NativePdfSettingsDialog({
  open,
  ready,
  title = 'Download PDF',
  onClose,
  onDownload,
}: {
  open: boolean;
  ready: boolean;
  title?: string;
  onClose: () => void;
  onDownload: (settings: PrintSettings) => void;
}) {
  const [print, setPrint] = useState<PrintSettings>(DEFAULT_PRINT_SETTINGS);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ pt: '12px !important' }}>
        <PrintSettingsFields value={print} onChange={setPrint} showImage={false} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!ready}
          onClick={() => {
            onClose();
            onDownload(print);
          }}
        >
          Download PDF
        </Button>
      </DialogActions>
    </Dialog>
  );
}
